<template>
    <app-layout :title="``">
        <template #header>
            <div class="flex w-full justify-between items-center" v-if="data">
                <h2 class="flex flex-col md:flex-row md:items-center md:text-[24px] text-[14px] leading-none"
                    v-html="title">
                </h2>
                <div class="flex gap-x-[5px] md:gap-x-[40px] justify-between items-center">

                    <div>
                        <div class="opacity-50 text-[12px] md:text-[14px]">{{ data.lastScan }}</div>
                    </div>

                    <div class="flex flex-row gap-[10px] md:gap-[20px]" v-if="0">
                        <jet-button v-if="prefixRoute" type="link"
                        :href="route(`${prefixRoute}.mention.index`)">Mentions</jet-button>
                        <jet-button v-if="prefixRoute" type="link"
                        :href="route(`${prefixRoute}.search-query.index`)">Queries</jet-button>
                    </div>
                    
                </div>
            </div>
        </template>

        <div class="mx-auto py-4" v-if="data">
            <BrandMonitoringDashboard :data="data" :prefixRoute="prefixRoute" />
            <pre v-if="0" class="bg-green-100 px-[20px]">{{ props }}</pre>
        </div>

    </app-layout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import JetButton from '@/Jetstream/Button.vue';
import BrandMonitoringDashboard from '@/Components/BrandMonitoring/BrandMonitoringDashboard.vue';

const props = defineProps({
    data: Object,
    title: String,
    prefixRoute: String
});
</script>